import { motion } from "framer-motion";

// A faint, black & white cinematic studio image that fades in behind a section header.
export default function HeaderBg({ image, position = "center" }) {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden>
      <motion.img
        src={image}
        alt=""
        initial={{ opacity: 0, scale: 1.08 }}
        whileInView={{ opacity: 0.14, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
        className="w-full h-[70%] object-cover grayscale contrast-125"
        style={{ objectPosition: position }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-obsidian/40 via-obsidian/80 to-obsidian" />
    </div>
  );
}

export const STUDIO = {
  console: "https://images.unsplash.com/photo-1517273006195-51fa3364bce2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  desk: "https://images.unsplash.com/photo-1574517947730-55cb23e608c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  mixer: "https://images.unsplash.com/photo-1618609377864-68609b857e90?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  mixer2: "https://images.unsplash.com/photo-1518972559570-7cc1309f3229?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  vinyl: "https://images.unsplash.com/photo-1761098281103-51bf33e39d7f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  mic: "https://images.unsplash.com/photo-1640957454144-392c8b05d5a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};
